import { render, staticRenderFns } from "./mConntect.vue?vue&type=template&id=6fca35ee&scoped=true&"
import script from "./mConntect.vue?vue&type=script&lang=js&"
export * from "./mConntect.vue?vue&type=script&lang=js&"
import style0 from "./mConntect.vue?vue&type=style&index=0&id=6fca35ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fca35ee",
  null
  
)

export default component.exports